<template>
	<div class="c-empty flex-column flex-center" :style="{'height': height}">
		<div class="c-empty-icon">
			<img :src="config.icon" />
		</div>
		<div class="c-empty-message">{{config.message}}</div>
	</div>
</template>

<script>
	export default {
		props: {
			type: String,
			height: String,
			message: {
				type: String,
				default: '暂无相关信息'
			}
		},

		computed: {
			config() {
				var config = {
					icon: require('@/assets/image/empty/common.png'),
					message: this.message
				};
				
				return config;
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-empty {
		height: 100%;
		
		&-icon {
			width: 120px;
			height: 120px;
		}

		&-message {
			line-height: 52px;
			font-size: 16px;
			color: #bbb;
		}
	}
</style>
